import { useNavigate, useParams } from "react-router-dom";

import { useCaseGeneralSettingsUpdateMutation, usePermissions } from "src/hooks";
import { useCase } from "src/hooks/useCase";
import { CaseGeneralSettingsMutationData, useCaseOsmpUpdateMutation } from "src/hooks/cases";
import { CaseGeneralSettingsForm } from "src/forms/CaseGeneralSettingsForm";
import { Pane } from "src/components/Pane";
import { isEnabled, isReadOnly } from "src/utils/permission.utils";

interface Props {}

export function CaseGeneralSettingsPage(props: Props) {
  const navigate = useNavigate();
  const { caseId = "" } = useParams<{ caseId: string }>();
  const { data: acase } = useCase(caseId);
  const { data: permissions } = usePermissions();

  const updateGeneralSettingsMutation = useCaseGeneralSettingsUpdateMutation(caseId);
  const { mutateAsync: updateOspm } = useCaseOsmpUpdateMutation(caseId);

  /**
   * Functions
   */

  function handleClose() {
    navigate(`/cases/${caseId}`);
  }

  async function handleSubmit(values: CaseGeneralSettingsMutationData) {
    if (!permissions) return;
    if (isEnabled(permissions?.cases.startOspm)) {
      await updateOspm(values.ospmEnabled);
    }
    await updateGeneralSettingsMutation.mutateAsync(values);
    handleClose();
  }

  return render();

  function render() {
    if (!acase) return null;
    if (!permissions) return null;
    return (
      <Pane>
        <CaseGeneralSettingsForm
          readOnly={isReadOnly(acase.permissions.updateGeneralSettings)}
          case={acase}
          errors={updateGeneralSettingsMutation.error?.response?.data}
          isLoading={updateGeneralSettingsMutation.isLoading}
          onSubmit={handleSubmit}
          onClose={handleClose}
          permissions={permissions}
        />
      </Pane>
    );
  }
}
